




















import Vue from 'vue';
import CancelIcon from '@/assets/img/icons/x.svg';
import TruncatedText from '@/vue-components/util/TruncatedText.vue';

export default Vue.component('LinkPreviewWidget', {
  name: 'LinkPreviewWidget.vue',
  components: {
    CancelIcon,
    TruncatedText,
  },
  props: {
    id: {
      type: String,
    },
    url: {
      type: String,
    },
    title: {
      type: String,
    },
    description: {
      type: String,
    },
    image: {
      type: String,
    },
    canDismiss: {
      type: Boolean,
    },
    onDismissCallback: {
      type: Function,
      default: () => {
        console.log('No action set.');
        return;
      },
    }
  },
});
